import React from 'react';
import { Loader2 } from 'lucide-react';

const PresentationImage = ({ imageUrl, isLoading }) => {
  // Image par défaut : Image de présentation EvoCore PACA
  const defaultImage = "https://picsum.photos/seed/evocore-paca/1024/576";
  const displayImage = imageUrl || defaultImage;
  
  return (
    <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-700/50 bg-slate-800/50 backdrop-blur-sm animate-fadeIn">
      {isLoading ? (
        <div className="flex items-center justify-center h-96 bg-slate-800">
          <Loader2 className="w-12 h-12 text-blue-400 animate-spin" />
        </div>
      ) : (
        <img
          src={displayImage}
          alt="Présentation du projet"
          className="w-full h-auto object-cover"
          loading="lazy"
          data-testid="presentation-img"
          onError={(e) => {
            // Si l'image ne charge pas, utiliser l'image par défaut
            if (e.target.src !== defaultImage) {
              e.target.src = defaultImage;
            }
          }}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent pointer-events-none" />
    </div>
  );
};

export default PresentationImage;
